import { CountryColorDataMap } from "./map-get-country-data";

/**
 * Lazily set the .world-map__region class for all tab-able regions.
 */
export const createRegionOverHandler =
  (countryData: CountryColorDataMap) => (_: unknown, code: unknown) => {
    if (typeof code !== "string" || !(code in countryData)) {
      return;
    }

    for (const element of document.querySelectorAll(
      `.jvectormap-region[data-code="${code}"]`
    )) {
      element.classList.add("world-map__region");
    }
  };
